import * as React from 'react';
import { CameraWrapper } from './CameraWrapper';

export interface LandingPageCamerasProps {
    cameras: Camera[];
    region: string;
    noImageUrl?: string;
}

export class Camera {
    public cameraId: number;
    public imageUrl: string;
    public name: string;
    public road: string;
    public isCurrent: boolean;
    public area: string;
    public url: string;
    public pageId: number;
    public thumbUrl: string;
}

export class LandingPageCameras extends React.Component<LandingPageCamerasProps> {
    public render(): JSX.Element {
        return <div className="camera-slider">{this.props.cameras.map(this.renderItem.bind(this))}</div>;
    }

    private renderItem(item: Camera): JSX.Element {
        return <CameraWrapper key={item.pageId} {...this.props} {...item} />;
    }
}
